import { createFileRoute } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth";
import { ActivityFeed } from "@/components/ActivityFeed";
import { Activity, ShieldAlert } from "lucide-react";

export const Route = createFileRoute("/_authenticated/soc")({
  component: SocPage,
  head: () => ({ meta: [{ title: "SOC — Security Operations Center" }] }),
});

function SocPage() {
  const { currentOrg } = useAuth();
  return (
    <div className="px-4 py-6 md:px-8 md:py-8">
      <div className="flex items-end justify-between gap-3">
        <div>
          <p className="text-xs font-medium uppercase tracking-wider text-primary">Security Operations Center</p>
          <h1 className="font-display text-2xl font-bold md:text-3xl flex items-center gap-2">
            <ShieldAlert className="h-6 w-6 text-primary" /> Live Activity
          </h1>
          <p className="text-sm text-muted-foreground">
            Realtime feed of every operational event across {currentOrg?.name ?? "your organization"}.
          </p>
        </div>
        <span className="inline-flex items-center gap-2 rounded-full border border-success/40 bg-success/10 px-3 py-1 text-xs text-success">
          <span className="h-2 w-2 animate-pulse rounded-full bg-success" /> Live
        </span>
      </div>

      <div className="mt-6 rounded-xl border border-border bg-card p-4 md:p-6">
        <div className="mb-3 flex items-center gap-2">
          <Activity className="h-4 w-4 text-primary" />
          <h2 className="font-display text-lg font-semibold">Operational stream</h2>
        </div>
        {currentOrg ? (
          <ActivityFeed orgId={currentOrg.id} limit={40} showFilters infinite autoScroll />
        ) : (
          <div className="text-sm text-muted-foreground">Select an organization to view activity.</div>
        )}
      </div>
    </div>
  );
}
